import AppInsightsService from "./app-insights";

export const appInsightsService = new AppInsightsService();
